
















import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import { Location } from "vue-router";
import DrivewealthDocuments from "@/shared/components/investments/drivewealth/DrivewealthDocuments.vue";
import RiskDisclaimer from "@/shared/components/investments/drivewealth/RiskDisclaimer.vue";
import DrivewealthNavigation from "@/shared/components/investments/drivewealth/DrivewealthNavigation.vue";
import { useDrivewealthStore } from "@/shared/store/drivewealth";

@Component({
  components: {
    DrivewealthDocuments,
    DrivewealthNavigation,
    RiskDisclaimer,
  }
})
export default class DrivewealthDocumentsPage extends Vue {
  @Prop() accountId: number;
  @Prop() pageNumber: number;
  @Prop() routeToPages: (page: number) => Location;
  @Prop() routeToDrivewealthDocuments: (pageNumber: number) => Location;
  @Prop() routeToDrivewealthDocumentsV2: (accountId: number, pageNumber: number) => Location;

  drivewealthStore = useDrivewealthStore();

  mounted (): void {
    if (this.accountId) {
      this.drivewealthStore.getAccountSummaryV2({ username: null, partnerId: null, dwAccountId: this.accountId });
    }
  }

  get accountTypeCopy (): string {
    if (this.accountId) {
      return this.drivewealthStore.accountManagementTypeTitleWithParensV2(this.accountId);
    }

    return this.drivewealthStore.accountManagementTypeTitleWithParens;
  }
}
